import { useCopySortable } from '../../../hooks/sortable';
export function useSorterCreateElement(ref, data) {
  useCopySortable(ref, {
    data: {
      type: 'create',
      data: data
    }
  });
}